import React from 'react'

import { Box, Card, RadioButton, Text } from '@factorialco/deprecated-design-system'
import {
  ReviewProcessCustomTemplateFragment,
  ReviewProcessPredefinedTemplateFragment,
} from 'generated/resources/graphql'

import { reviewTypePicker } from 'modules/performance_process/components/common/filters/reviewTypePicker'

interface TemplateCardProps {
  template: ReviewProcessPredefinedTemplateFragment | ReviewProcessCustomTemplateFragment
  selectedTemplateId?: string
  onDataChanged: () => void
}

export const TemplateCard: React.FC<TemplateCardProps> = ({
  template,
  selectedTemplateId,
  onDataChanged,
}) => {
  return (
    <Card key={template.id} onClick={onDataChanged}>
      <Card.Title
        action={
          <RadioButton
            size="medium"
            onChange={onDataChanged}
            checked={selectedTemplateId === template.id}
            value={`${template.id}`}
          />
        }
      >
        {template.name}
      </Card.Title>
      <Card.Content>
        <Box gap="s24">
          {template.reviewerStrategies && template.reviewerStrategies.length > 0 && (
            <Text.Normal>
              {template.reviewerStrategies.map((type) => reviewTypePicker(type)).join(' | ')}
            </Text.Normal>
          )}
          <Text.Normal>{template.templateDescription}</Text.Normal>
        </Box>
      </Card.Content>
    </Card>
  )
}
